import {useCallback, useState} from 'react';
import {IUTMItem} from "../../../../types/home";

export const useCoordinatesManagement = () => {
  const [UTMData, setUTMData] = useState<{ [key: string]: IUTMItem }>({});
  const [showUTM, setShowUTM] = useState(false);

  const handleChangeUTMData = useCallback((index: string, item: IUTMItem) => {
    setUTMData(prevData => ({
      ...prevData,
      [index]: {
        east: item.east,
        north: item.north,
        zone: item.zone,
      }
    }));
  }, []);

  return {
    UTMData,
    showUTM,
    setShowUTM,
    handleChangeUTMData
  };
};
